import * as React from 'react'
import styled from 'styled-components'
import { COLORS } from 'static/constants'

interface IProps {
  children: React.ReactNode
  content: React.ReactNode | string
  position?: 'top' | 'bottom' | 'left' | 'right'
}

/**
 * ツールチップ
 * @param children ホバー対象
 * @param content ツールチップの内容
 * @returns
 */
export const Tooltip = ({ children, content, position = 'top' }: IProps) => {
  // contentが空文字、またはスペースしか存在しない場合はツールチップを表示しない
  if (typeof content === 'string' && content.trim() === '') {
    return <>{children}</>
  }
  return (
    <TooltipWrapper>
      <div className={`tooltipContent ${position}`} role="tooltip">
        {content}
      </div>
      {children}
    </TooltipWrapper>
  )
}

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
  .tooltipContent {
    width: max-content;
    position: absolute;
    max-width: 180px;
    font-size: 10px;
    z-index: 1;
    color: ${COLORS.white};
    background-color: ${COLORS.tooltipBG};
    padding: 4px 8px;
    border-radius: 4px;
    display: none;
    white-space: pre-wrap;
    word-break: keep-all;
    overflow-wrap: break-word;
    overflow-wrap: anywhere;
    line-height: normal;

    &.top {
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      margin-bottom: 8px;
    }
    &.bottom {
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 8px;
    }
    &.left {
      top: 50%;
      right: 100%;
      transform: translateY(-50%);
      margin-right: 8px;
    }
    &.right {
      top: 50%;
      left: 100%;
      transform: translateY(-50%);
      margin-left: 8px;
    }
  }
  &:hover .tooltipContent {
    display: block;
  }
`
